import React from 'react';
import { H3, Subtitle, PackageDescriptionList } from 'react-design-components';
import { Box } from '@material-ui/core';
import PackageSelector from './PackageSelector';
import { ComponentsEnum, FlowEnum } from '../../types';
import { MainLayout } from '../MainLayout';
import usePackage from './hooks/usePackage';
import { HTMLParsedText } from '../../components/Shared';

interface Props {
  progress?: number;
  flow?: FlowEnum;
}

const Underline: React.FC<{ children?: React.ReactNode }> = ({ children }: { children?: React.ReactNode }) => (
  <span style={{ textDecoration: 'underline' }}>{children}</span>
);

const Package: React.FC<Props> = (props: Props) => {
  const { t, pageTitle, classes, products, onSelect, commonProductAttributes, partnerProductWithRefrenceInput } =
    usePackage();

  const { progress, flow = FlowEnum.CHECK_PRIVATE } = props;

  return (
    <MainLayout
      navigationId={ComponentsEnum.PACKAGE}
      flow={flow}
      progress={progress}
      directAccess
      t={t}
      pageTitle={pageTitle}
      hideNavigation={true}
      hidBackButton={true}
      fullWidth={true}
    >
      <div className={classes.alignTop}>
        <Box mb={2}>
          <H3>{t('package_title')}</H3>
          {partnerProductWithRefrenceInput?.id && (
            <Box mb={4} className={classes.partnerPromo}>
              <Subtitle margined>
                {
                  // conditionText is a string containing html that is received via the API
                  // we let Trans parse this for us, its XSS safe
                  // default supported tags include: strong, i, p.
                  // Others need to be defined in the compontents prop
                  partnerProductWithRefrenceInput.integratedPartner?.conditionText ? (
                    <span aria-label="condition text">
                      <HTMLParsedText html={partnerProductWithRefrenceInput.integratedPartner.conditionText} />
                    </span>
                  ) : (
                    <>
                      {t('package_free_legal_insurance_choose')}
                      <b>{`${partnerProductWithRefrenceInput.integratedPartner?.name.toUpperCase()}.`}</b>
                      {t('package_free_legal_insurance_promo')}
                      <Underline>{t('package_free_legal_insurance_promo_2')}</Underline>
                      {t('package_free_legal_insurance_promo_3')}
                    </>
                  )
                }
              </Subtitle>
            </Box>
          )}
          <div style={{ marginTop: 30 }}>
            <PackageDescriptionList active={true} items={commonProductAttributes} title={t('package_subtitle')} />
          </div>
        </Box>
        <PackageSelector products={products} onSelect={onSelect} isDisabled={() => false} />
      </div>
    </MainLayout>
  );
};

export default Package;
